import React from 'react'
import { Popover, Typography } from '@material-ui/core'
import { compose, withState, withHandlers } from 'recompose'
import { TableHeaderTooltipIcon } from './statelessDataTable/styles'
import { PosterCheckModalHelpIcon } from '../../compliance/components/common/column.tooltip.styles'

const TooltipRenderer = ({
  toolTip,
  labelText,
  anchorEl,
  handlePopoverOpen,
  handlePopoverClose,
  styling
}) => (
  <React.Fragment>
    {labelText}
    <TableHeaderTooltipIcon
      style={styling}
      onMouseOver={handlePopoverOpen}
      onFocus={handlePopoverOpen}
    >
      <PosterCheckModalHelpIcon />
    </TableHeaderTooltipIcon>
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onMouseOut={handlePopoverClose}
      onBlur={handlePopoverClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      marginThreshold={24}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
      PaperProps={{
        elevation: 4,
        square: true,
        component: 'span',
        style: {
          maxWidth: '40%',
          minWidth: '20%',
          padding: '1rem',
          margin: '1rem'
        }
      }}
    >
      <Typography paragraph={false}>{toolTip}</Typography>
    </Popover>
  </React.Fragment>
)

const tooltipHandlers = {
  handlePopoverOpen: (props) => (event) => {
    props.setTooltipAnchor(event.currentTarget)
  },

  handlePopoverClose: (props) => (event) => {
    props.setTooltipAnchor(null)
  }
}

const TooltipComponent = compose(
  withState('anchorEl', 'setTooltipAnchor', null),
  withHandlers(tooltipHandlers)
)(TooltipRenderer)

export default TooltipComponent
